import React, { useState } from 'react';
import { saveConsentState } from '../lib/analytics';
import { loadGoogleAnalytics } from '../lib/analytics';
import { initPostHog } from '../providers/PostHogProvider';

interface CookieBannerProps {
  onConsent: (accepted: boolean) => void;
}

const CookieBanner: React.FC<CookieBannerProps> = ({ onConsent }) => {
  const [visible, setVisible] = useState(true);

  const handleAccept = () => {
    saveConsentState('accepted');
    loadGoogleAnalytics();
    initPostHog();
    setVisible(false);
    onConsent(true);
  };

  const handleDecline = () => {
    saveConsentState('declined');
    setVisible(false);
    onConsent(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed bottom-0 left-0 right-0 z-[100] p-4 sm:p-6 flex justify-center pointer-events-none"
    >
      <div className="w-full max-w-2xl bg-white rounded-2xl shadow-xl border border-slate-200 p-5 pointer-events-auto flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-slate-900 mb-1">We use cookies</p>
          <p className="text-sm text-slate-500 leading-relaxed">
            We use analytics cookies (Google Analytics &amp; PostHog) to understand how the app is used and improve it.
            The app works fully without them.
          </p>
        </div>
        <div className="flex gap-3 shrink-0 w-full sm:w-auto">
          <button
            type="button"
            onClick={handleDecline}
            className="flex-1 sm:flex-none px-4 py-2 text-sm font-semibold text-slate-700 border border-slate-200 rounded-xl hover:bg-slate-50 transition-colors"
          >
            Decline
          </button>
          <button
            type="button"
            onClick={handleAccept}
            className="flex-1 sm:flex-none px-5 py-2 text-sm font-bold text-white bg-blue-600 rounded-xl hover:bg-blue-700 transition-colors"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
